import { render, staticRenderFns } from "./VisaPopup.vue?vue&type=template&id=a4dce51a&"
import script from "./VisaPopup.vue?vue&type=script&lang=js&"
export * from "./VisaPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports